import { useEffect } from "react";

const n8nDataCollection = async (data) => {
  const endpoint = "https://mywonder.app.n8n.cloud/webhook/registration";
  const n8n_api_key = process.env.REACT_APP_N8N_API_KEY;

try {
    const response = await fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "apiKey":n8n_api_key
      },
      body: JSON.stringify(data),
    });

    const api_response = await response.json();
    // console.log("POST response:", api_response);
  } catch (err) {
    console.error("POST error:", err);
  }
};

export default n8nDataCollection;
